import { Component, Input } from '@angular/core';
import { ModalController } from "@ionic/angular";

@Component({
  selector: 'app-video-player-modal',
  templateUrl: './video-player-modal.component.html',
  standalone: false
})
export class VideoPlayerModalComponent {
  @Input() videoUrl!: string;

  constructor(private modalController: ModalController) { }

  dismissModal() {
    this.modalController.dismiss();
  }
}
